/**
 * Конфиг модулей расчёта. От модуля зависит шаг «файл» (uploadType) и маршрут после загрузки (route).
 * Добавление нового модуля: добавить объект с id, label, route, uploadType.
 */
export const calculationModules = [
  {
    id: 'standard',
    label: 'Стандартный расчёт TCP/NTCP',
    route: '/app/structure-model-selection',
    uploadType: 'single_dvh',
    icon: 'fas fa-calculator',
    description:
      'Расчёт радиобиологических метрик и критериев в рамках одного режима облучения (одна ГДО) на базе классической линейно-квадратичной модели (ЛКМ).',
  },
  {
    id: 'interval',
    label: 'Расчёт TCP/NTCP с неопределённостью',
    route: '/app/structure-model-selection-interval',
    uploadType: 'single_dvh',
    icon: 'fas fa-chart-area',
    description:
      'Расчёт радиобиологических метрик и критериев с учётом стандартного отклонения или доверительного интервала параметров модели в рамках одного режима облучения (одна ГДО) на базе классической линейно-квадратичной модели (ЛКМ).',
  },
  {
    id: 'lq',
    label: 'Расчёт TCP/NTCP для гипофракционирования',
    route: '/app/structure-model-selection-lq',
    uploadType: 'single_dvh',
    icon: 'fas fa-dna',
    description:
      'Расчёт радиобиологических метрик и критериев в рамках одного режима облучения (одна ГДО) на базе моделей клеточной гибели при гипофракционном облучении MLQ, LQL, PLQ, USC.',
  },
  {
    id: 'adaptive_rt',
    label: 'Расчёт TCP/NTCP с множеством ГДО',
    route: '/app/structure-model-selection-adaptive-rt',
    uploadType: 'multi_dvh_stages',
    icon: 'fas fa-layer-group',
    description:
      'Расчёт радиобиологических метрик и критериев для смешанных режимов облучения (несколько ГДО) в рамках одного курса лучевой терапии.',
  },
  {
    id: 'neutron_photon',
    label: 'Расчёт TCP/NTCP для сочетанного нейтрон-фотонного облучения',
    route: null,
    uploadType: null,
    available: false,
    icon: 'fas fa-atom',
    description:
      'Расчёт радиобиологических метрик и критериев с учётом специфических радиобиологических параметров при сочетанном нейтрон-фотонном облучении.',
  },
];

/** Модули с объединённым экраном параметров курса + загрузка ГДО */
export const COMBINED_SETUP_MODULE_IDS = ['standard', 'interval'];

export function usesCombinedSetup(moduleId) {
  return COMBINED_SETUP_MODULE_IDS.includes(moduleId);
}

/** Модуль можно выбрать и открыть курс. Карточка без расчётного шага остаётся на экране выбора. */
export function isCalculationModuleAvailable(moduleOrId) {
  const calcModule = typeof moduleOrId === 'string'
    ? findCalculationModuleById(moduleOrId)
    : moduleOrId;
  if (!calcModule) return false;
  return calcModule.available !== false;
}

/**
 * Найти модуль по id без запасного значения.
 * @returns {object|null}
 */
export function findCalculationModuleById(moduleId) {
  if (!moduleId) return null;
  return calculationModules.find((m) => m.id === moduleId) || null;
}

/**
 * Найти модуль по id. Неизвестный id даёт первый модуль (совместимость со старыми вызовами).
 */
export function getCalculationModuleById(moduleId) {
  return findCalculationModuleById(moduleId) || calculationModules[0];
}
